module.exports = __webpack_public_path__ + "static/media/rica.7590887c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadBackgroundImg/rica.jpg
// module id = 726
// module chunks = 0